<div class="dialog-viewer">
    <h2 mat-dialog-title>Create Price</h2>
    <form [formGroup]="form" (ngSubmit)="submit(form)">
        <mat-dialog-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Simulator</mat-label>
                            <mat-select placeholder="Simulator" required name="simulatorId" id="simulatorId"
                                type="text" formControlName="simulatorId">
                                <mat-option *ngFor="let simulator of simulators" [value]="simulator.id">{{simulator.bayNumber}} ({{simulator.bayName}})</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('simulatorId').errors?.required">Simulator is required
                            </mat-error>
                            <mat-error *ngIf="form.get('simulatorId').errors?.validationErrors">
                                {{ form.get("simulatorId").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Price Band</mat-label>
                            <mat-select placeholder="Prce Band" required name="priceBandId" id="priceBandId"
                                type="text" formControlName="priceBandId">
                                <mat-option *ngFor="let priceBand of priceBands" [value]="priceBand.id">{{priceBand.name}} ({{priceBand.description}})</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('priceBandId').errors?.required">Price Band is required
                            </mat-error>
                            <mat-error *ngIf="form.get('priceBandId').errors?.validationErrors">
                                {{ form.get("priceBandId").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Amount</mat-label>
                            <span matTextPrefix>$ &nbsp;</span>
                            <input required matInput name="amount" id="amount" placeholder="Amount" type="number"
                                formControlName="amount" />
                            <mat-error *ngIf="form.get('amount').errors?.required">Amount is required
                            </mat-error>
                            <mat-error *ngIf="form.get('amount').errors?.validationErrors">
                                {{ form.get("amount").errors?.validationErrors}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Duration</mat-label>
                            <mat-select formControlName="durationMinutes" required>
                                <mat-option *ngFor="let duration of availableDurations" [value]="duration.durationMinutes">{{duration.durationMinutes | minutesToHours}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="text-center">
                <button mat-raised-button type="submit" [disabled]="isLoading">Save</button>
                <button mat-raised-button type="button" (click)="dialogRef.close('cancel')" class="warning"
                    [disabled]="isLoading">Cancel</button>
            </div>
        </mat-dialog-actions>
    </form>
</div>